<!-- =========================================================================================
  File Name: BookAdd.vue
  Description: Book Add Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-book-add">

    <vx-card title="교재 상세 정보" class="mb-base" >
      <book-add-form class="mt-4" />
    </vx-card>

  </div>
</template>

<script>
import BookAddForm  from './BookAddForm'

export default {
  components: {
    BookAddForm
  },
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
  }
  
}

</script>
